// extracted by css-extract-rspack-plugin
var _1 = "TOL74YRLDI5HYsRi";
var _2 = "oc0wN2C9ScUBP7Kh";
export { _1 as "dropdown", _2 as "menu" }
